import { createAction, createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { backfillAttendanceSheets } from "./backfill-attendance-sheets";

const initialState: ProcessingState = { processing: "idle" };

export const resetBackfillAttendanceSheets = createAction("admin/resetBackfillAttendanceSheets");

export const backfillAttendanceSheetsReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(backfillAttendanceSheets.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(backfillAttendanceSheets.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(backfillAttendanceSheets.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetBackfillAttendanceSheets, () => {
    return initialState;
  });
});
